class Element {
  // private int atomicNum;
  // private int px;
  // private int py;
  // private int color;
  // private String name;
  // private String symbol;
  // private String category;

  constructor(props) {
    this.atomicNum = props.number;
    this.px = props.xpos - 1;
    this.py = props.ypos;
    this.name = props.name;
    this.symbol = props.symbol;
    this.category = props.category;
    this.mass = props.atomic_mass;
    this.proton = props.prominentIsotope.proton;
    this.neutron = props.prominentIsotope.neutron;
  }

  getColor() {
    return "#ffffff";
  }
}

export default Element;
